__turbopack_context__.v({
  "next-posts": "PostsList-module-scss-module___9_Boq__next-posts",
  "pagination": "PostsList-module-scss-module___9_Boq__pagination",
  "posts-grid": "PostsList-module-scss-module___9_Boq__posts-grid",
  "prev-posts": "PostsList-module-scss-module___9_Boq__prev-posts",
});
